var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { DIAGRAM_CONTAINER_ID } from '../types';
var NODE_LINK_CONNECTOR_VERTICAL_OFFSET = 22;
export var useNodeDomPositions = function (nodes, columns) {
    var _a = useState(0), lastRecalculateTime = _a[0], setLastRecalculateTime = _a[1];
    var _b = useState({}), nodePositions = _b[0], setNodePositions = _b[1];
    var onContainerResize = useCallback(function () {
        setLastRecalculateTime(Date.now());
    }, []);
    useEffect(function () {
        var onScroll = function () {
            setLastRecalculateTime(Date.now());
        };
        window.addEventListener('scroll', onScroll, true);
        return function () { return window.removeEventListener('scroll', onScroll); };
    }, []);
    useLayoutEffect(function () {
        var newNodePositions = {};
        nodes.forEach(function (node) {
            var containerBox = getDiagramContainerBoundingBox();
            var nodeBox = getNodeBoundingBoxById(containerBox, node.id);
            newNodePositions[node.id] = {
                leftAnchor: getCenterLeftOfNodeBox(nodeBox),
                rightAnchor: getCenterRightOfNodeBox(nodeBox),
            };
        });
        setNodePositions(newNodePositions);
    }, [lastRecalculateTime, columns]);
    return {
        onContainerResize: onContainerResize,
        nodePositions: nodePositions,
    };
};
var getDiagramContainerBoundingBox = function () {
    var _a;
    return (_a = document.getElementById(DIAGRAM_CONTAINER_ID)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
};
var getNodeBoundingBoxById = function (parent, id) {
    var _a;
    var target = (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    if (!parent || !target) {
        return undefined;
    }
    return __assign(__assign({}, target), { right: target.right - parent.left, left: target.left - parent.left, top: target.top - parent.top, bottom: target.bottom - parent.top });
};
var getCenterRightOfNodeBox = function (box) {
    return box
        ? { x: box.right - 1, y: box.top + NODE_LINK_CONNECTOR_VERTICAL_OFFSET }
        : undefined;
};
var getCenterLeftOfNodeBox = function (box) {
    return box
        ? { x: box.left + 1, y: box.top + NODE_LINK_CONNECTOR_VERTICAL_OFFSET }
        : undefined;
};
//# sourceMappingURL=nodeDomPositions.js.map